import React, {Component} from 'react'
import FJLocalStore from '../../../store/FJLocalStore'
import {connect} from "react-redux";
import FJExportPreview from "../view/FJExportPreview";
import {FJExportPreviewAction} from "../../../redux/action/FJRoot.action";
import key from 'keymaster'
import FJCoreUtil from "../../../core/util/FJCoreUtil";

class FJExportPreviewContainer extends Component {

  componentDidMount() {
    key('space', 'exportPreview',  () => {

      // 让音量面板收起来
      FJCoreUtil.triggerBodyMousedown();
      this._togglePlayPreview();
    });
  }

  _togglePlayPreview = (toggle) => {
    if (this.props.introStatus === 'success') {
      this.props.togglePlayPreview(toggle);
    }
  };

  getView = () => {
    return this._preview.getView();
  };

  getPreviewSize = () => {
    return {
      width: this.props.previewWidth,
      height: this.props.previewHeight,
    }
  };

  _setPreviewVolume = (type, progress) => {
    switch (type) {
      case 'changeStart':
        key.setScope('');
        break;
      case 'changeEnd':
        key.setScope('exportPreview');
        break;
      default:
    }
    this.props.setPreviewVolume(progress);
  };

  render() {
    const {introStatus, isPlaying, duration, currentTime, volume, width, height, previewWidth, previewHeight} = this.props;
    const {seekPreview, onUpdateCanvasSize, onRetry} = this.props;
    return (
      <FJExportPreview width={width}
                       height={height}
                       previewWidth={previewWidth}
                       previewHeight={previewHeight}
                       ref={ele => {this._preview = ele}}
                       onPlay={this._togglePlayPreview}
                       onRetry={onRetry}
                       onSeek={seekPreview}
                       isPlaying={isPlaying}
                       duration={duration}
                       currentTime={currentTime}
                       volume={volume}
                       retryDesc={FJLocalStore._('retry-load-intro')}
                       retryText={FJLocalStore._('retry')}
                       onVolumeChange={this._setPreviewVolume}
                       introStatus={introStatus}
                       onUpdateCanvasSize={onUpdateCanvasSize}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    introStatus: state.intro.introStatus,
    isPlaying: state.exportPreview.isPlaying,
    duration: state.exportPreview.duration,
    currentTime: state.exportPreview.currentTime,
    volume: state.exportPreview.volume,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    togglePlayPreview: function (toggle) {
      dispatch(FJExportPreviewAction.toggleExportPreviewPlayAction(toggle))
    },
    seekPreview: function (type, progress) {
      dispatch(FJExportPreviewAction.seekExportPreviewAction(type, progress));
    },
    setPreviewVolume: function (volume) {
      dispatch(FJExportPreviewAction.setGlobalVolumeAction(volume, {shouldCache: true}));
    },
  }
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(FJExportPreviewContainer)
